<template>
	<button class="btn btn-icon" :disabled="loading">
		<spinner v-if="loading" size="small"/>
		<svgicon v-else :name="icon" :fill="false"/>
	</button>
</template>

<script>
export default {
	props: [
		'loading',
		'click',
		'icon'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonIconLoading.vue